import { Component, Input, OnInit } from '@angular/core';
import { ApiError, MessageService } from '../../../../../core';
import { PedidoItemDescontoMaximoExcedidoResponse } from '../../adapters';
import { PedidoItemHttpService } from '../../services';
import { take } from 'rxjs/operators';

interface Config {
    isLoading: boolean;
}

@Component({
    selector: 'pedido-item-desconto-maximo-excedido-table-view',
    templateUrl: './pedido-item-desconto-maximo-excedido-table-view.component.html',
    styleUrls: ['./pedido-item-desconto-maximo-excedido-table-view.component.less']
})
export class PedidoItemDescontoMaximoExcedidoTableViewComponent implements OnInit {
    config: Config;
    pedidosItens: PedidoItemDescontoMaximoExcedidoResponse[];
    // Table
    @Input() idTable = 'tablePedidoItensDescontosMaximosExcedidos';

    constructor(private messageService: MessageService,
                private pedidoItemHttpService: PedidoItemHttpService) { }

    ngOnInit(): void {
        this.createConfig();
    }


    private createConfig() {
        this.config = {
            isLoading: false
        };
    }

    /** Pesquisa os itens de um pedido que possui os percentuais de descontos excedidos, ou seja, acima do limite permitido */
    search(idPedido: number): Promise<void | ApiError> {
        return new Promise<void | ApiError>((resolve, reject) => {
            this.config.isLoading = true;
            this.pedidosItens = [];
            this.pedidoItemHttpService.searchDescontosMaximosExcedidos(idPedido)
                .pipe(take(1))
                .subscribe(
                    response => {
                        this.pedidosItens = response;
                        this.config.isLoading = false;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.cause, error.message, error);
                        this.config.isLoading = false;
                        reject(error);
                    }
                )
        });
    }
}
